// Brumby Brew Coffee - Theme JavaScript
// High-End Boutique, Yet Fun & Cute

const BrumbyBrew = {
  cart: [],
  config: {
    currency: 'USD',
    locale: 'en'
  }
};

// Initialize theme
document.addEventListener('DOMContentLoaded', function() {
  initializeTheme();
  initializeFAQ();
  initializeAnimations();
  initializeBrewingGuides();
  initializeProductMicroInteractions();
});

// Theme initialization
function initializeTheme() {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

// Format price
function formatPrice(cents) {
  var dollars = cents / 100;
  return '$' + dollars.toFixed(2);
}

function showNotification(message) {
  var notification = document.createElement('div');
  notification.className = 'brumby-notification';
  notification.style.cssText = 'position: fixed; bottom: 24px; right: 24px; background-color: var(--color-primary); color: var(--color-cream); padding: 16px 28px; border-radius: 12px; z-index: 10000; animation: slideIn 0.4s ease-out; font-family: var(--font-body); font-size: 14px; font-weight: 600; box-shadow: var(--shadow-lg);';
  notification.textContent = message;
  document.body.appendChild(notification);

  setTimeout(function() {
    notification.style.animation = 'slideOut 0.25s ease';
    setTimeout(function() { notification.remove(); }, 250);
  }, 3000);
}

// FAQ functionality
function initializeFAQ() {
  var faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(function(item) {
    var question = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');
    var toggle = item.querySelector('.faq-toggle');
    if (!question || !answer) return;

    question.addEventListener('click', function() {
      var isActive = item.classList.contains('active');

      // Close all others
      faqItems.forEach(function(i) {
        i.classList.remove('active');
        var q = i.querySelector('.faq-question');
        var t = i.querySelector('.faq-toggle');
        if (q) q.setAttribute('aria-expanded', 'false');
        if (t) t.textContent = '+';
      });

      // Toggle current
      if (!isActive) {
        item.classList.add('active');
        question.setAttribute('aria-expanded', 'true');
        if (toggle) toggle.textContent = '−';
      }
    });
  });
}

// Scroll animations with Intersection Observer
function initializeAnimations() {
  var observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Assign stagger delays to cards within each grid, then mark as will-animate
  document.querySelectorAll('.features-grid, .products-grid, .taste-profile__grid').forEach(function(grid) {
    grid.querySelectorAll('.feature-card, .product-card, .taste-profile__card').forEach(function(card, i) {
      card.style.setProperty('--stagger-delay', (i * 0.1).toFixed(2) + 's');
    });
  });

  document.querySelectorAll('.feature-card, .product-card, .faq-item, .taste-profile__card').forEach(function(el) {
    el.classList.add('will-animate');
    observer.observe(el);
  });
}

// Brewing Guide toggle
function initializeBrewingGuides() {
  document.querySelectorAll('.brewing-guide__toggle').forEach(function(toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    var guideId = toggle.getAttribute('aria-controls');
    toggle.addEventListener('click', function() {
      var guide = toggle.closest('.brewing-guide');
      if (guide) {
        guide.classList.toggle('active');
        var isActive = guide.classList.contains('active');
        toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  });
}

// Cute micro-interactions on product cards
function initializeProductMicroInteractions() {

  // Taste profile card hover tilt (subtle)
  document.querySelectorAll('.taste-profile__card').forEach(function(card) {
    var rafPending = false;
    var lastE = null;

    card.addEventListener('mousemove', function(e) {
      lastE = e;
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function() {
        rafPending = false;
        var rect = card.getBoundingClientRect();
        var x = lastE.clientX - rect.left;
        var y = lastE.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = (y - centerY) / centerY * -2;
        var rotateY = (x - centerX) / centerX * 2;
        card.style.transform = 'translateY(-4px) perspective(500px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
      });
    });

    card.addEventListener('mouseleave', function() {
      rafPending = false;
      card.style.transform = 'translateY(0) perspective(500px) rotateX(0deg) rotateY(0deg)';
    });
  });
}

// Cart: Add to cart via AJAX
// btn (optional) — the triggering button, disabled during request to prevent double-adds
function addToCart(variantId, quantity, btn) {
  quantity = quantity || 1;

  // Prevent double-submit if a button is provided
  if (btn) {
    if (btn._atcInProgress) return;
    btn._atcInProgress = true;
    btn.disabled = true;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(function(response) {
    if (!response.ok) throw new Error('Could not add to cart');
    return response.json();
  })
  .then(function() {
    updateCartCount();
    showNotification('Added to your bag!');
  })
  .catch(function(err) {
    console.error(err);
    showNotification('Could not add item. Please try again.');
  })
  .finally(function() {
    if (btn) {
      btn._atcInProgress = false;
      btn.disabled = false;
    }
  });
}

// Cart: Update item quantity
function updateCartItem(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
  .then(function(response) { return response.json(); })
  .then(function() {
    window.location.reload();
  })
  .catch(function(err) {
    console.error(err);
    showNotification('Could not update cart. Please try again.');
  });
}

// Cart: Fetch current cart and update header badge
function updateCartCount() {
  fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      var badge = document.querySelector('.header__cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      }
    });
}

// Product form AJAX submission is handled in sections/product.liquid

// Export for global access
window.BrumbyBrew = BrumbyBrew;
window.formatPrice = formatPrice;
window.addToCart = addToCart;
window.updateCartItem = updateCartItem;
